module.exports = __webpack_public_path__ + "img/WhxKECPNujWoWEFNdnJE.4e81901b.png";